import "@aws-amplify/ui-react/styles.css";
import React from "react";
import TeamDisplay from "../controls/TeamDisplay";
import BasePage from "../controls/BasePage";
import NotFound from "./NotFound";
import { LoadingBlock } from "../controls/LoadingBlock";
import PostDisplay from "../controls/PostDisplay";
import { Box, Center } from "@chakra-ui/react";

class ViewPost extends BasePage {
    render() {
        if (this.state.data == null) {
            return <LoadingBlock />;
        }
        
        const location = window.location;
        const paths  = location.pathname.split('/');
        const postId = paths[1];

        //const post = this.state.data.Teams.find(t => t.id === postId);
        const post = {
            title: "Hello, World",
            body: ``
        }
        if (post == null) {
            return <NotFound message="Team Not Found"/>;
        }
        return (<>
            <Center>
                <Box w="fill" m={20} maxW="1000">
                    <PostDisplay post={post} />
                </Box>
            </Center>
            </>);
    }
}

export default ViewPost;